import basicController from "servicestack/basic.controller.properties";
import $resolve from "ng";
import authConfig from "emun.auth/auth.config"; //get shared
import modals from "webmodals/modals";
import $session from "servicestack/session";

export default class ChooseRetailerController {
  constructor($window) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.config = authConfig;
    $ctrl.bus = $ctrl.$session.bus;
    delete $ctrl.bus.validationErrors;
    console.debug("ChooseRetailerController", this);
    $ctrl.retailers = JSON.parse($ctrl.$session.meta.RetailerBillTos);
    console.debug("BL*** retailerbilltos", $ctrl.$session.meta.RetailerBillTos);
    console.debug("BL*** retailers", $ctrl.retailers);
    $ctrl.bus.send("QueryUsers.json?Id=" + $ctrl.$session.userAuthId).then(function(res) {
      if (res.data.results.length) $ctrl.user = res.data.results[0];
    });
  }

  selectRetailer(r) {
    let $ctrl = this;
    $ctrl.user.retailerId = $ctrl.$session.retailerId = r.id;
    $ctrl.bus.send("SwitchRetailer.json", {
      UserAuthId: $ctrl.$session.userAuthId,
      RetailerId: $ctrl.user.retailerId
    }).then(function(res) {
      $ctrl.$dismiss();
      $session.$broadcast("$retailerChosen");
      
      // if ($session.isSalesManagementMode()) {
      //   $timeout(() => {
      //     window.location = "/";
      //   }, 2000);
      // } else {
      //   location.reload();
      // }
    });
    
  }

}
